import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientProfile from "@/pages/ClientProfile";
import ImportContacts from "@/pages/Import";
import Campaigns from "@/pages/Campaigns";
import ManualSend from "@/pages/ManualSend";
import Templates from "@/pages/Templates";
import History from "@/pages/History";
import Followups from "@/pages/Followups";
import Reports from "@/pages/Reports";
import WhatsAppPage from "@/pages/WhatsApp";
import Settings from "@/pages/Settings";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-10 w-10 rounded-full border-4 border-emerald-500 border-t-transparent animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="clientes" element={<Clients />} />
              <Route path="clientes/:id" element={<ClientProfile />} />
              <Route path="importar" element={<ImportContacts />} />
              <Route path="disparos" element={<Campaigns />} />
              <Route path="envio-manual" element={<ManualSend />} />
              <Route path="modelos" element={<Templates />} />
              <Route path="historico" element={<History />} />
              <Route path="followups" element={<Followups />} />
              <Route path="relatorios" element={<Reports />} />
              <Route path="whatsapp" element={<WhatsAppPage />} />
              <Route path="configuracoes" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
